export function formatDate(value) {
  if (!value) return "—";
  try {
    const d = new Date(value.length <= 10 ? value + "T00:00:00" : value);
    if (isNaN(d)) return String(value);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()}`;
  } catch {
    return String(value);
  }
}

export function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  const t = d.toLocaleTimeString("it-IT", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Rome",
  });
  return `${formatDate(value)} ${t}`;
}

export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (isNaN(n)) return String(value);
  return n.toLocaleString("it-IT", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatCurrency(value, decimals = 2) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (isNaN(n)) return String(value);
  return "€ " + formatNumber(n, decimals);
}

export function formatCell(value, field) {
  if (value === null || value === undefined || value === "") return "—";
  switch (field.type) {
    case "bool":
      return value ? "Sì" : "No";
    case "date":
      return formatDate(value);
    case "decimal":
      return formatNumber(value, field.decimals || 2);
    case "number":
      return formatNumber(value, 0);
    default:
      return String(value);
  }
}
